module.exports = __webpack_public_path__ + "static/media/zone_3.df75bc4a.png";